import { DTOError } from 'src/error/errors/DTOError';
import type { MetaPolicy } from './types';

export const metaPoliciesDTO = (data: unknown): MetaPolicy[] => {
  if (data && Array.isArray(data)) {
    return data.map((metaPolicy) => metaPolicyDTO(metaPolicy));
  }

  throw new DTOError('metaPoliciesDTO', data);
};

const metaPolicyDTO = (data: unknown): MetaPolicy => {
  if (
    data &&
    typeof data === 'object' &&
    'id' in data &&
    'name' in data &&
    'calculation_type' in data &&
    'price' in data &&
    'price_converted' in data &&
    'currency' in data
  ) {
    return {
      id: typeof data.id === 'number' ? data.id : 0,
      name: typeof data.name === 'string' ? data.name : '',
      calculation_type:
        data.calculation_type === 0 ||
        data.calculation_type === 1 ||
        data.calculation_type === 2 ||
        data.calculation_type === 3
          ? data.calculation_type
          : 0,
      price: typeof data.price === 'number' ? data.price : 0,
      price_converted:
        typeof data.price_converted === 'number' ? data.price_converted : 0,
      currency: typeof data.currency === 'string' ? data.currency : '',
    };
  }

  throw new DTOError('metaPolicyDTO', data);
};
